
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 72 72","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('rect',{attrs:{"width":"72","height":"72","rx":"4"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M34.8 40.802V29.294l-3.954 3.953-1.697-1.697L36 24.699l6.851 6.85-1.697 1.698-3.954-3.953v11.508h-2.4zm8.403 4.802v-2.401h2.401v2.401a2.403 2.403 0 01-2.401 2.401H28.797a2.402 2.402 0 01-2.401-2.401v-2.401h2.401v2.401h14.406z","fill":"currentColor"}})])
          )
        }
      }
    